import React, { useEffect, useState } from "react";
import SmetaTabs from "../../../Tools/Tabs/SmetaTabs";
import GraphTable from "./SectionGraphComponents/GraphTable";
import { SmetaTabItem } from "../../../Tools/Tabs/PinIcons";
import SimpleGraph from "./SectionGraphComponents/SimpleGraph";
import clsx from "clsx";
import graphStyles from "./graphStyles.module.css";
import { createContext } from "react";

const tabsData = [
  { caption: "Таблица", id: "0" },
  { caption: "График", id: "1" },
];

interface SectionGraphProps {
  data: {
    ArchTypes: string;
    CLSID: string;
    Chart: any;
    Cols: { [key: string]: {} };
    Fields: { [key: string]: {} };
    Rows: { [key: string]: {} };
    Table: { RCDATA: string };
    ViewIdent: string;
  };
}

export const SectionGraphContext = createContext<SectionGraphContextData | null>(null);

export interface SectionGraphContextData {
  setCharts?: (val: any) => void;
  chart?: any;
  cols?: { [key: string]: {} };
  fields?: { [key: string]: {} };
  rows?: { [key: string]: {} };
  table?: { RCDATA: string };
  viewIdent?: string;
}

const getTabs = () => {
  const components: { [key: string]: () => React.JSX.Element } = {
    "0": () => <GraphTable />,
    "1": () => <SimpleGraph />,
  };
  return tabsData.map((item, index) => {
    return (
      <SmetaTabItem label={item.caption} key={`Section-graph-tab_${index}`}>
        {components[item.id]?.()}
      </SmetaTabItem>
    );
  });
};

const SectionGraph = (props: SectionGraphProps) => {
  const { data } = props;
  const {
    ArchTypes: archTypes,
    CLSID: clsid,
    Chart: chart,
    Cols: cols,
    Fields: fields,
    Rows: rows,
    Table: table,
    ViewIdent: viewIdent,
  } = data;

  const [tabs, setTabs] = useState<React.JSX.Element[]>([]);
  const [charts, setCharts] = useState<any>(chart);
  const [context, setContext] = useState<SectionGraphContextData>({});

  useEffect(() => {
    setTabs(getTabs());
  }, []);

  useEffect(() => {
    const contextData = {
      setCharts: (val: any) => setCharts(val),
      chart: charts,
      cols,
      fields,
      rows,
      table,
      viewIdent,
    };
    setContext(contextData);
  }, [props, charts]);

  return (
    <div className={clsx(graphStyles.mainGraphBlock)}>
      <SectionGraphContext.Provider value={context}>
        <div className={clsx(graphStyles.graphTabsContainer)}>
          {context.viewIdent ? <SmetaTabs style={{ flex: "1 1 0", width: "100%" }}>{tabs}</SmetaTabs> : <SimpleGraph />}
        </div>
      </SectionGraphContext.Provider>
    </div>
  );
};

export default SectionGraph;
